import type { IconProps } from './types';

export const Mail01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M0.75 0.75H21.375V17.625H0.75V0.75Z" stroke={color} strokeWidth="1.5" />
      <path d="M0.75 3.5625L11.0625 9.1875L21.375 3.5625" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
